/**
 * Author: Wilson Pilco Nuñez
 * Email: wilsonaux1@gmail.com
 * Created at: 2026-08-20 16:51
 */
import http from "src/utils/http.js";

class ReportServices {
  static async charismaReport01(params) {
    return (await http.get("api/report-custom/charisma-01", { params })).data;
  }
}

export default ReportServices;
